import React, { useCallback, useState, useEffect } from 'react';
import type { OrgBasicFilterType } from '@/app-package';

import { AgentsContext, AgentsContextUser } from 'contexts';

type AgentContextProviderProps = {
  fetchOrgUsers: (
    filter?: OrgBasicFilterType,
    targetUserIds?: string[],
  ) => Promise<AgentsContextUser[]>;
};

const AgentContextProvider: React.FC<AgentContextProviderProps> = ({
  fetchOrgUsers,
  children,
}) => {
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    (async () => {
      if (!agents.length) {
        const orgAgents = await fetchOrgUsers();

        setAgents(orgAgents);
      }
    })();
  }, [fetchOrgUsers, agents.length]);

  const fetch = useCallback(
    async (filter?: OrgBasicFilterType, targetUserIds?: string[]) => {
      const orgAgents = await fetchOrgUsers(filter, targetUserIds);
      setAgents(orgAgents);

      return orgAgents;
    },
    [fetchOrgUsers],
  );

  return (
    <AgentsContext.Provider
      value={{ orgUsers: agents, orgUsersMap: {}, fetchOrgUsers: fetch }}
    >
      {children}
    </AgentsContext.Provider>
  );
};

export default AgentContextProvider;
